import React from "react";
import { CreateQuoteRootScreenContext } from "./context";

export const useCreateSaleQuoteRootScreenContextProvider = () => {
  const context = React.useContext(CreateQuoteRootScreenContext);
  if (!context) {
    throw new Error(
      "No CreateQuoteRootScreenContextType context was provided."
    );
  }
  return context;
};
